import React, { useState, useEffect } from 'react';
import { removeDiacritics } from '../../utils/stringUtils';

export const useStringSearch = (
  list: any[],
  property: string,
  additionalHandleChangeFn: Function | null = null,
) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([] as any[]);

  const handleChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(value);
    if (additionalHandleChangeFn) additionalHandleChangeFn(value);
  };

  useEffect(() => {
    const results = list.filter((item: { [state: string]: string }) =>
      removeDiacritics(item[property]).includes(removeDiacritics(searchValue)),
    );
    setSearchResults(results);
  }, [searchValue, list, property]);

  return { handleChange, searchResults, searchValue };
};
